/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
// tslint:disable:no-submodule-imports no-import-side-effect
import { NgModule } from '@angular/core';
import { CoreMlsModule, JSONTranslationMapLoader, provideTranslationMapLoader } from '@gh/core-mls';
import '@gh/supplier-shared/mls/supplier.mls.json';
import * as i0 from "@angular/core";
import * as i1 from "../../core-mls/core-mls.module";
var SupplierMlsConfigModule = /** @class */ (function () {
    function SupplierMlsConfigModule() {
    }
    SupplierMlsConfigModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierMlsConfigModule });
    SupplierMlsConfigModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SupplierMlsConfigModule_Factory(t) { return new (t || SupplierMlsConfigModule)(); }, providers: [
            provideTranslationMapLoader(JSONTranslationMapLoader),
        ], imports: [[
                CoreMlsModule.forRoot(),
            ],
            CoreMlsModule] });
    return SupplierMlsConfigModule;
}());
export { SupplierMlsConfigModule };
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupplierMlsConfigModule, { imports: [i1.CoreMlsModule], exports: [CoreMlsModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierMlsConfigModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CoreMlsModule.forRoot(),
                ],
                providers: [
                    provideTranslationMapLoader(JSONTranslationMapLoader),
                ],
                exports: [
                    CoreMlsModule,
                ],
            }]
    }], null, null); })();
